var _circle, _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 252,
    height: 252,
    viewBox: "0 0 252 252",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 126,
    cy: 126,
    r: 50,
    fill: "#F5B320"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_468_209)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 126,
    cy: 126,
    r: 50,
    fill: "#F5B320"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M119.336 121.72C118.88 120.88 118.22 120.244 117.356 119.812C116.516 119.356 115.52 119.128 114.368 119.128C112.376 119.128 110.78 119.788 109.58 121.108C108.38 122.404 107.78 124.144 107.78 126.328C107.78 128.656 108.404 130.48 109.652 131.8C110.924 133.096 112.664 133.744 114.872 133.744C116.384 133.744 117.656 133.36 118.688 132.592C119.744 131.824 120.512 130.72 120.992 129.28H113.18V124.744H126.572V130.468C126.116 132.004 125.336 133.432 124.232 134.752C123.152 136.072 121.772 137.14 120.092 137.956C118.412 138.772 116.516 139.18 114.404 139.18C111.908 139.18 109.676 138.64 107.708 137.56C105.764 136.456 104.24 134.932 103.136 132.988C102.056 131.044 101.516 128.824 101.516 126.328C101.516 123.832 102.056 121.612 103.136 119.668C104.24 117.7 105.764 116.176 107.708 115.096C109.652 113.992 111.872 113.44 114.368 113.44C117.392 113.44 119.936 114.172 122 115.636C124.088 117.1 125.468 119.128 126.14 121.72H119.336ZM139.126 139.288C137.158 139.288 135.382 138.868 133.798 138.028C132.238 137.188 131.002 135.988 130.09 134.428C129.202 132.868 128.758 131.044 128.758 128.956C128.758 126.892 129.214 125.08 130.126 123.52C131.038 121.936 132.286 120.724 133.87 119.884C135.454 119.044 137.23 118.624 139.198 118.624C141.166 118.624 142.942 119.044 144.526 119.884C146.11 120.724 147.358 121.936 148.27 123.52C149.182 125.08 149.638 126.892 149.638 128.956C149.638 131.02 149.17 132.844 148.234 134.428C147.322 135.988 146.062 137.188 144.454 138.028C142.87 138.868 141.094 139.288 139.126 139.288ZM139.126 133.96C140.302 133.96 141.298 133.528 142.114 132.664C142.954 131.8 143.374 130.564 143.374 128.956C143.374 127.348 142.966 126.112 142.15 125.248C141.358 124.384 140.374 123.952 139.198 123.952C137.998 123.952 137.002 124.384 136.21 125.248C135.418 126.088 135.022 127.324 135.022 128.956C135.022 130.564 135.406 131.8 136.174 132.664C136.966 133.528 137.95 133.96 139.126 133.96Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_468_209",
    x: 36,
    y: 56,
    width: 180,
    height: 180,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.960784 0 0 0 0 0.701961 0 0 0 0 0.12549 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_468_209"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_468_209",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGo);
export default __webpack_public_path__ + "static/media/Go.c2fce7cc662b3fbbab9093f5dcdcef56.svg";
export { ForwardRef as ReactComponent };